module.exports = __webpack_public_path__ + "img/Affiliate-Banner-Mobile.493c27d.jpg";